<template lang="pug">
form(@submit.prevent="onSave")
  p.text-large - Confirme os dados do modelo
  .py-2
    div
      section
        h1.h5 Tipo do documento
        .columns
          item-col.my-1.col-12(
            label="doc_modelo.tipo",
            :value="resource | enums('doc.tipo')"
          )
        .divider

      section
        h1.h5 Informações do modelo
        .columns
          item-col.my-1.col-12(
            label="doc_modelo.titulo",
            :value="resource.titulo"
          )
          item-col.my-1.col-12(
            label="doc_modelo.descricao",
            :value="resource.descricao"
          )
          .column.col-12.my-2
            span {{ "doc_modelo.ativo" | tModel }}:
              span.text-bold {{ resource.ativo | simNao }}
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.info', query: $route.query }"
          )
            btn-content(name="edit")
        .divider
      section
        h1.h5 Parâmetros
        .columns
          item-col.my-2.col-6.col-sm-12(
            label="Limite de autuações",
            :value="osmParams('limite_autuacao')"
          )
          item-col.my-2.col-6.col-sm-12(
            label="Mínimo de fotos",
            :value="osmParams('minimo_fotos')"
          )
          item-col.my-1.col-6.col-sm-12(
            label="doc_modelo.prazo",
            :value="`${resource.prazo} ${resource.prazo !== 1 ? 'dias' : 'dia'}`"
          )
          item-col.my-1.col-6.col-sm-12(
            label="doc_modelo.tipo_implantacao",
            :value="resource | enums('doc.tipo_implantacao')"
          )
          item-col.my-1.col-12(
            label="doc_modelo.debito_tipo",
            :value="`${resource.debito_tipo_id || ''} - ${resource.debito_tipo.descricao || ''}`"
          )
          item-col.col-12.my-2(
            label="Situação na ciência",
            :value="resource.situacao_na_ciencia_id | docSituacao"
          )
          item-col.my-2.col-12(
            label="Permite emitir mesmo com Documento em andamento",
            :value="osmParams('permite_mesmo_em_andamento ') | simNao"
          )
          item-col.my-2.col-12(
            label="Implantar automaticamente ao dar ciência no documento",
            :value="resource.implantar_na_ciencia | simNao"
          )
          item-col.my-2.col-12(
            label="Implantar automaticamente ao autuar o documento",
            :value="resource.implantar_ao_autuar | simNao"
          )
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.parametros', query: $route.query }"
          )
            btn-content(name="edit")
        .divider
      section
        h1.h5 Cálculo
        div(v-if="osmParams('calculo.tipo_valor_parametro')")
          .columns
            item-col.my-2.col-12(
              label="Coluna de cálculo",
              :value="`enums.db.enum_doc_valor_tipo.${osmParams('calculo.tipo_valor_parametro')}` | translate"
            )
            .column.col-12.my-2(
              v-if="osmParams('calculo.tipo_valor_parametro') === 'area'"
            )
              span Utilizar a área definida no cadastro:
                b &nbsp;{{ osmParams("calculo.buscar_area_do_cadastro") | simNao }}
          .columns(v-if="osmParams('calculo.regras').length > 0")
            .column.mt-2.col-12
              .abbr Regras de cálculo
            .column.col-12
              table.table.table-sm
                thead
                  tr
                    th Tipo
                    th Parâmetro inicial
                    th Parâmetro final
                    th Valor
                    th Fração
                tbody
                  tr(v-for="regra in osmParams('calculo.regras')")
                    td {{ regra.tipo | calculoTipo }}
                    td {{ regra.parametro_inicial | currency }}
                    td {{ regra.parametro_final | currency }}
                    td
                      span(v-if="regra.tipo !== 'determinado'") {{ regra.valor | currency("R$ ") }}
                      span(v-else) -
                    td
                      span(v-if="regra.tipo === 'multiplicador_por_fracao'") {{ regra.fracao | currency() }}
                      span(v-else) -
        div(v-else) Nenhuma regra de cálculo adicionada
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.calculo', query: $route.query }"
          )
            btn-content(name="edit")
        .divider 
      section
        h1.h5 Reincidência
        .columns
          item-col.my-2.col-3.col-sm-12(
            label="Prazo para reincidência",
            :value="`${osmParams('reincidencia.prazo_considerar')} ${osmParams('reincidencia.prazo_considerar') === 1 ? 'dia' : 'dias'}`"
          )
          item-col.my-2.col-3.col-sm-12(
            label="Multiplicador",
            :value="`x ${osmParams('reincidencia.multiplicador')}`"
          )
          item-col.my-2.col-3.col-sm-12(
            label="Permite desconto",
            :value="osmParams('reincidencia.permite_desconto ') | simNao"
          )
          item-col.my-2.col-3.col-sm-12(
            label="Quantidade limite",
            :value="osmParams('reincidencia.quantidade_limite') | simNao"
          )
          item-col.my-2.col-12(
            label="Origem da base de cálculo",
            :value="osmParams('reincidencia.origem_ultimo_valor') ? 'Valor da última autuação' : 'Valor atual da irregularidade'"
          )
        .columns
          .column.mt-2.col-12
            .abbr Prazos por reincidência
          .column.col-12.my-2(
            v-for="(prazo, numero) in osmParams('reincidencia.prazos')"
          )
            span Reincidência {{ Number(numero) + 1 }}:
              span.text-bold &nbsp;{{ prazo }} {{ prazo === 1 ? "dia" : "dias" }}
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.reincidencia', query: $route.query }"
          )
            btn-content(name="edit")
        .divider
      section
        h1.h5 Assuntos
        .columns
          .column.col-12.my-2
            span Verificar notificação aguardando regularizar: #[span.text-bold {{ osmParams("assuntos.notificacao") }}]
          .column.col-12.my-2
            span Verificar pedido de desconto: #[span.text-bold {{ osmParams("assuntos.desconto") }}]
          .column.col-12.my-2
            span Verificar autuação:
              span.text-bold &nbsp;{{ osmParams("assuntos.autuacao") }}
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.assuntos', query: $route.query }"
          )
            btn-content(name="edit")
        .divider
      section
        h1.h5 Irregularidades
        div(v-if="resource.params.osm.irregularidades.length > 0")
          .pb-2.mb-2(
            v-for="irregularidade in resource.params.osm.irregularidades",
            :key="irregularidade.codigo"
          )
            i.fa.fa-check-square-o
            small {{ irregularidade.descricao }}
        div(v-else) #[cite Nenhuma irregularidade adicionada]
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.irregularidades', query: $route.query }"
          )
            btn-content(name="edit")
        .divider 
      section
        h1.h5 Integração
        .columns
          item-col.col-12.my-2(
            label="Atualizar Cadastro no Tributário?",
            :value="osmParams('altera_situacao_mobiliario') | situacaoMobiliario"
          )
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.integracao', query: $route.query }"
          )
            btn-content(name="edit")
        .divider
      section
        h1.h5 Textos
        .my-2.p-2.bg-gray.s-rounded(v-for="texto in resource.textos")
          .text-center.mb-2 {{ texto.titulo }}
          .text-long {{ texto.descricao }}
        .mt-2
          router-link.no-decoration.text-small(
            :to="{ name: 'sistema.docModelos.edit.integracao', query: $route.query }"
          )
            btn-content(name="edit")
  .pt-2
    .divider
    button.btn.btn-primary(:disabled="loading", :class="{ loading }")
      btn-content(name="save")
</template>

<script>
import editMixin from "./mixin"
import { deepKey } from "paliari-js-utils"

export default {
  vuex: {
    "sistema/docModelos": {
      actions: ["fetchUpdate"],
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  mixins: [editMixin],
  computed: {
    situacoesNaCiencia() {
      return {
        2: "Notificado",
        12: "Autuado",
        13: "Aguardando Regularizar",
      }
    },
  },
  methods: {
    osmParams(path) {
      return deepKey(this.resource.params.osm, path)
    },
    async onSave() {
      try {
        this.loading = true
        await this.fetchUpdate(this.resource.postParams)
        this.$toaster.success("Modelo alterado com sucesso")
        this.$router.replace({ name: "app.sistema.docModelos" })
      } catch (e) {
        this.$toaster.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
